















import { ICalendarDoor } from '@/common/interfaces/announcement-bar.interface';
import Bauble from '@/components/announcementbar/christmas-calendar/subcomponents/Bauble.vue';
import PartnerShopHelper from '@/helpers/page-specific/PartnerShopHelper';
import TIcons from '@/types/TIcons';
import Vue from 'vue';

export default Vue.extend({
  name: `ChristmasCalendarDesktopView`,
  components: { Bauble },
  computed: {
    logoPath(): string {
      return PartnerShopHelper.isPageInPartnerShop() ? TIcons.ringanaLogoPartner : TIcons.ringanaLogo;
    },
  },
  props: {
    doors: {
      required: true,
      type: Array as () => ICalendarDoor[],
    },
  },
});
